<template>
    <DefaultLayout>
        <DefaultHeader :showHeader=true :language="this.lang" />
        <div id="content" class="container-fluid">
            <TabStrip :selected="selectedTab" @select="onSelectTab" class="tab-strip" :tabs="tabs">
                <template v-slot:MainView>
                    <div class="row">
                        <div class="control-group">
                            <label class="">Warehouse&nbsp;&nbsp;</label>
                            <dropdownlist :style="{ width: '230px' }" :data-items="warehouses" :value="selectedWarehouse"
                                          text-field="branchName" value-field="branchName"
                                          @change="onChangeWarehouse">
                            </dropdownlist>
                            <VueDatePicker v-model="dateRange" range :preset-dates="presetDates" :max-date="today" :format="format" class="dateRange" @update:model-value="onChangeDateRange">
                                <template #preset-date-range-button="{ label, value, presetDate }">
                                    <span role="button"
                                          :tabindex="0"
                                          @click="presetDate(value)"
                                          @keyup.enter.prevent="presetDate(value)"
                                          @keyup.space.prevent="presetDate(value)">
                                        {{ label }}
                                    </span>
                                </template>
                            </VueDatePicker>
                            <span class="custom-padding">
                                
                                    <KButton :theme-color="'primary'" @click="exportToExcel">Export</KButton>
                                    <KButton :theme-color="'primary'" @click="clearFilter">Clear Filter</KButton>
                             
                            </span>
                        </div>
                    </div>
                    <div class="row">
                        <Grid ref="grid" :columns="columns" :style="{height: '640px', fontSize: '12px'}"
                              :data-items="filterEntries" :edit-field="'inEdit'" :sortable="true" :sort="sort"
                              :pageable="pageable" :take="take" :skip="skip" :total="total" :editable="true"
                              :filterable="true" :filter="gridFilter" @filterchange="filterChange" :showBottomNav="false"
                              :loader="loader">
                            <template v-slot:commandTemplate="{ props }">
                                <command :data-item="props.dataItem" @edit="editEntry" />
                            </template>
                            <grid-norecords> There is no data available custom </grid-norecords>
                        </Grid>
                        <div style="margin-top: 10px; margin-left: 15px; font-size: 14px; font-weight: bold;">
                            Total Rows: {{ totalCount }}
                        </div>
                        <dialog-container v-if="entryInEdit"
                                          :data-item="entryInEdit"
                                          :statuses="tabs"
                                          @save="saveEntry"
                                          @cancel="cancelEntry">
                        </dialog-container>
                    </div>
                </template>
            </TabStrip>
        </div>
    </DefaultLayout>
</template>
<style scoped>
    .tab-strip {
        font-size: 14pt;
    }
    .k-dialog {
        padding: 20px;
        min-width: 600px;
    }
    .k-dialog .k-form {
        font-size: 14px;
    }
    .k-input-value-text.k-input {
        font-size: 14px;
    }
    input.k-input {
        font-size: 14px;
        padding-bottom: 1px;
    }
    textarea.k-input-inner {
        font-size: 14px;
    }
    .k-form-horizontal .k-form-field {
        padding-bottom: 2px;
    }
    .k-form-horizontal .k-form-field > .k-form-label {
        width: 110px;
    }
    .k-form .k-form-field-wrap {
    }
    .k-grid {
        margin: 15px;
    }
    .k-table-md {
        font-size: 14px !important;
    }
    .k-grid .k-button {
        height: 35px;
        margin: 4px 10px;        
    }
    .k-grid .k-table-th, .k-table-md, .k-grid td, .k-grid .k-table-td {
        font-size: 14px !important;
    }

    .dp__clear_icon {
        display: none;
    }
    .k-grid .k-table {
        background-color: inherit;
        font-size: 14px;
    }
    .k-button-solid-primary {
        font-size: 14px;
        background-color: green;
        color: white;
        border-color: green;
    }

    .dp__input, .dp__btn, .dp__cell_inner, .dp__calendar_header_item {
        font-size: 14px;
    }

    .dp__selection_preview {
        font-size: 16px;
    }

    .dp__action_button {
        font-size: 14px;
    }

    .dp--preset-range {
        color: blue;
    }

    .control-group {
        display: flex;
        align-items: flex-start;
        margin: 15px;
        font-size: 14px;
    }

    .dateRange {
        width: 260px;
        padding-left: 10px;
    }

    .k-input-value-text {
        font-size: 14px !important;
    }

    .k-list {
        font-size: 14px;
    }
    .k-tabstrip-items-wrapper .k-item {
        color: blue !important;
    }
    .k-tabstrip-items-wrapper .k-active {
        color: black !important;
    }
    .k-tabstrip-items .k-link {
            font-size: 14px;
        }
    .custom-padding {
        padding-left: 15px;
        display: flex;
        gap:30px;
    }
    .k-button {
        line-height: 22px;
    }
    .k-checkbox {

    }
    .k-checkbox-md {
        width: var(--kendo-spacing-6, 1rem);
        height: var(--kendo-spacing-6, 1rem);
    }
    .k-checkbox-lg {
        width: var(--kendo-spacing-8, 1rem);
        height: var(--kendo-spacing-8, 1rem);
    }
    .k-checkbox:checked {
        border-color: green;
        background-color: green;
    }
    .k-filtercell-operator {
        display: none !important;
    }
    .parent-container {
        pointer-events: auto;
    }
    .k-pager {
        display: none !important;
    }

</style>
<script>
    import { ref } from 'vue'
    import '@progress/kendo-theme-default/dist/all.css';
    import { TabStrip } from '@progress/kendo-vue-layout';
    import { Grid, GridNoRecords } from '@progress/kendo-vue-grid';
    import { filterBy, orderBy } from '@progress/kendo-data-query';
    import { DropDownList } from '@progress/kendo-vue-dropdowns';
    import { Button as KButton } from "@progress/kendo-vue-buttons";
    import VueDatePicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css';
    import { addDays, startOfWeek, endOfWeek, startOfMonth, endOfMonth, endOfYear, startOfYear, subMonths, subYears } from 'date-fns';
    import SiteFocusCommandCell from './SiteFocusCommandCell';
    import SiteFocusDialog from './SiteFocusDialog';
    import DefaultHeader from '../layouts/DefaultHeader.vue';
    import DefaultLayout from '../layouts/DefaultLayout.vue';
    import '@fortawesome/fontawesome-free/css/all.min.css';
    import ExcelJS from 'exceljs';
    import { saveAs } from 'file-saver';
    import { store } from '../stores/store.js';
    import { format } from "date-fns";

    export default {
        name: "SiteFocusView",
        components: {
            DefaultHeader,
            DefaultLayout,
            Grid: Grid,
            'grid-norecords': GridNoRecords,
            'dropdownlist': DropDownList,
            command: SiteFocusCommandCell,
            'dialog-container': SiteFocusDialog,
            VueDatePicker,
            TabStrip,
            KButton,
            
        },
        setup: function () {

            const dateRange = ref([new Date(new Date().setDate(new Date().getDate() - 30)), new Date()]);

            const format = 'MM-dd-yyyy'; // Adjust the format as needed

            const presetDates = ref([
                { label: 'Today', value: [new Date(), new Date()] },
                { label: 'Yesterday', value: [addDays(new Date(), -1), addDays(new Date(), -1)] },
                { label: 'Last 7 Days', value: [addDays(new Date(), -6), new Date()] },
                { label: 'This Week', value: [startOfWeek(new Date()), new Date()] },
                { label: 'Last Week', value: [startOfWeek(addDays(new Date(), -7)), endOfWeek(addDays(new Date(), -7))] },
                { label: 'Last 30 Days', value: [addDays(new Date(), -29), new Date()] },
                { label: 'This month', value: [startOfMonth(new Date()), endOfMonth(new Date())] },
                { label: 'Last month', value: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))], },
                { label: 'This year', value: [startOfYear(new Date()), endOfYear(new Date())] },
                { label: 'Last year', value: [startOfYear(subYears(new Date(), 1)), endOfYear(subYears(new Date(), 1))] },
                { label: '3 Months', value: [startOfMonth(subMonths(new Date(), 3)), new Date()] },
                { label: '6 Months', value: [startOfMonth(subMonths(new Date(), 6)), new Date()] },
                { label: '12 Months', value: [startOfMonth(subMonths(new Date(), 12)), new Date()] },
            ]);
            return {
                dateRange,
                presetDates,
                format,
            }
        },

        data: function () {
            return {
                today: new Date(),
                isApprover: false,
                fromDate: new Date((new Date).toLocaleDateString()),
                toDate: new Date((new Date).toLocaleDateString()),
                filter: null,
                sort: [{field: "dateSubmitted1", dir: "desc"}],
                pageable: true,
                entries: [],
                skip: 0,
                take: 10,
                total: 0,
                updatedData: [],
                editID: null,
                entryInEdit: undefined,
                columns: [
                    { cell: 'commandTemplate', filterable: false, width: '75px' },
                    { field: 'employeeNumber', title: 'Emp #', width: '75px', operator: 'contains' },
                    { field: 'employeeFirstName', title: 'First Name', width: '110px', operator: 'contains' },
                    { field: 'employeeLastName', title: 'Last Name', width: '110px', operator: 'contains' },
                    { field: 'reason', title: 'Category', width: '230px', operator: "contains"},
                    { field: 'supervisor', title: 'Supervisor', width: '120px', operator: 'contains' },
                    { field: 'description', title: 'Description', operator: 'contains'},
                    { field: 'correctiveAction', title: 'Action Taken', operator: 'contains' },
                    { field: 'dateSubmitted', title: 'Date', width: '90px', filterable: false, sortable: true },
                    { field: 'branchName', title: 'Whs', width: '60px', operator: 'contains' },
                    { field: 'nearMiss', title: 'Near Miss', width: '100px', operator: 'contains' },
                    { field: 'nearMissType', title: 'Near Miss Type', operator: 'contains' },
                    { field: 'id', editable: false, hidden: true, title: 'id'},
                    { field: 'branchLocationId', editable: false, hidden: true, title: 'Branch Location ID'},
                ],
                loader: false,
                labels: {
                    headerText: 'View Entry'
                },
                selectedTab: 0,
                tabs: [],
                selectedWarehouse: { branchName: 'All Warehouses' },
                warehouses: [],
                wayneLogoUrl: require('@/assets/img/logos/WayneLogo.png'),

                gridFilter: {
                    logic: 'and',
                    filters: [],
                },                
            };
        },

        computed: {
            dataState() {
                return {
                    sort: this.sort,
                    skip: this.skip,
                    take: this.take,
                };
            },
            filterEntries: function () {
                return orderBy(filterBy(this.entries, this.gridFilter), this.sort);
            },
            totalCount() {
                return this.filterEntries.length;
            },
        },
        
        created: async function () {
            await this.getStatuses();
            this.getWarehouses();
            this.getMainData();
        },

        mounted() {
            this.isApprover = store.isApprover;
        },
        methods: {
            getStatuses: function () {
                return fetch('/sharpEntries/statuses')
                    .then((response) => response.json())
                    .then((json) => {
                        const order = ['Pending', 'Approved', 'Rejected'];
                        this.tabs = json
                            .sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name))
                            .map(status => ({
                                id: status.id,
                                title: status.label,
                                content: 'MainView'
                            }));
                });
            },
            filterChange: function (ev) {
                this.gridFilter = ev.filter;
            },
            footerCellRender() {
                return `Total: ${this.totalCount}`;
            },

            clearFilter: function() {
                this.gridFilter = {
                    logic: 'and',
                    filters: [],                                
                }
            },
            editEntry: function (dataItem) {
                this.entryInEdit = dataItem;
            },
            saveEntry: function () {
                const requestOptions = {
                    method: 'POST',
                    accept: 'application/json',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        id: this.entryInEdit.id,
                        isApproved: this.entryInEdit.isApproved,
                        rejectionId: this.entryInEdit.isApproved == 0 ? this.entryInEdit.rejectionId : null,
                        branchName: this.entryInEdit.branchName,
                        branchLocationId: this.entryInEdit.branchLocationId
                    })
                };

                fetch(`/sharpEntries/updateEntry`, requestOptions)
                    .then(() => {
                        let index = this.entries.findIndex(x => x.id == this.entryInEdit.id);
                        const selectedStatusId = this.tabs[this.selectedTab].id;
                        const entryStatusId = this.entryInEdit.isApproved;
                        if (selectedStatusId === entryStatusId) {
                            this.entries[index] = this.entryInEdit;
                        }
                        else {
                            this.entries.splice(index, 1);
                        }
                        this.entryInEdit = undefined;
                    });
            },
            cancelEntry: function () {
                this.entryInEdit = undefined;
            },
            onSelectTab: function (event) {
                this.selectedTab = event.selected;
                this.getMainData();
            },
            getWarehouses: function () {
                const parent = this;

                const requestOptions = {
                    method: 'POST', accept: 'application/json', headers: {
                        Accept: 'application/json', 'Content-Type': 'application/json'
                    }
                };

                fetch(`/sharpBranch/getAllBranches`, requestOptions)
                    .then((response) => response.json())
                    .then((json) => {
                        parent.warehouses = json;
                        parent.warehouses.unshift({ branchName: 'All Warehouses' });

                    });
            },
            getMainData: function() {
                const that = this;
                this.loader = true;
                const branchName = (this.selectedWarehouse.branchName === "All Warehouses") ? "" : this.selectedWarehouse.branchName;

                const requestOptions = {
                    method: 'POST', 
                    accept: 'application/json', 
                    headers: {
                        Accept: 'application/json', 
                        'Content-Type': 'application/json'
                    }, 
                    body: JSON.stringify({ 
                        branchName: branchName, 
                        fromDate: this.dateRange[0],
                        toDate: this.dateRange[1],
                        status: this.tabs[this.selectedTab].id
                    })
                }

                fetch(`/sharpEntries/getSharpEntriesByDate`, requestOptions)
                    .then((response) => response.json())
                    .then((json) => {
                        that.total = json['recordsTotal']
                        that.entries = json['data'];
                        this.loader = false;
                    });
            },

            onChangeWarehouse: function (event) {
                this.selectedWarehouse = event.value;
                this.getMainData();
            },

            onChangeDateRange: function () {
                this.getMainData();
            },

            async exportToExcel() {    
                const maxColumns = 16;
                const startingRow = 11;

                const currentDate = new Date();
                const currentMonth = currentDate.toLocaleString('default', { month: 'long' });

                // Create a new workbook and worksheet
                const workbook = new ExcelJS.Workbook();
                const worksheet = workbook.addWorksheet('Detail');

                               
                worksheet.addRow([]);
                this.makeBoldFont(worksheet.addRow(['Company Name:', '', 'SIMI Holdings']));
                this.makeBoldFont(worksheet.addRow(['Submitted By:', '', 'Lisa Layfield']));
                this.makeBoldFont(worksheet.addRow(['Date Submitted:', '', this.formatDate(currentDate), 'submitted - date', `${currentMonth} Pts.`]));
                worksheet.addRow([]);
                this.makeBoldFont(worksheet.addRow(['Date Uploaded*:']));
                this.makeBoldFont(worksheet.addRow(['Uploaded By*:']));
                this.makeBoldFont(worksheet.addRow(['*Internal Use Only']));
                worksheet.addRow([]);
                worksheet.addRow([]);

                const rowHeader = worksheet.addRow(['First Name', 'Last Name', 'Company', 'Department', 'Employee ID', 'Supervisor', 'Birthday', `${currentMonth} Points`, `${currentMonth} Points Submitted`, 'Type', 'Description', 'Action Taken', 'Reason', 'Termination Date', 'Near Miss', 'Near Miss Type']);
                rowHeader.height = 38                
                rowHeader.alignment = { vertical: 'middle' };
                rowHeader.font = { bold: true };
                

                this.applyThinBordersToRowsColumns(worksheet, 2, 4, 3, 6);
                this.applyThinBordersToRowsColumns(worksheet, 6, 7, 3, 6);
                this.applyThinBordersToRowsColumns(worksheet, 11, 11, 1, maxColumns);

                // Add data rows
                this.entries.forEach((item) => {
                    const newRow = worksheet.addRow([
                        item.employeeFirstName,
                        item.employeeLastName,
                        item.branchName,
                        item.department,
                        item.employeeNumber.toString().padStart(6, '0'),
                        item.supervisor,
                        'N/A',
                        item.points,
                        item.points,
                        item.reason,
                        item.description,
                        item.correctiveAction,
                        currentMonth,
                        '',
                        item.nearMiss,
                        item.nearMissType,
                    ]);
                    this.applyThinBorders(newRow);
                });


                // Load the logo image as a base64 string
                const logoBase64 = await this.loadImageBase64(this.wayneLogoUrl);

                // Add the logo image to the worksheet
                const imageId = workbook.addImage({
                    base64: logoBase64,
                    extension: 'png'
                });
                worksheet.addImage(imageId, {
                    tl: { col: 9, row: 2 },
                    ext: { width: 150, height: 50 }
                });


                worksheet.autoFilter = { from: { row: startingRow, column: 1 }, to: { row: this.entries.length + startingRow, column: maxColumns } };
                this.autoResizeColumns(worksheet);

                const pointsTotal = {};

                this.entries.forEach( (x) => {
                    const key = `${x.employeeNumber.toString().padStart(6, '0')}`;

                    if (pointsTotal[key]) {
                        pointsTotal[key].points += x.points;
                        pointsTotal[key].pointsSubmitted += x.points;
                    }
                    else {
                        pointsTotal[key] = {
                            firstName: x.employeeFirstName, lastName: x.employeeLastName, company: x.branchName, department: x.department,
                            employeeNumber: `${x.employeeNumber.toString().padStart(6, '0')}`, birthday: 'N/A', points: x.points, pointsSubmitted: x.points
                        };
                    }
                });

                const sheetTotal = workbook.addWorksheet('Total');
                const rowHeader2 = sheetTotal.addRow(['First Name', 'Last Name', 'Company', 'Department', 'Employee ID', 'Birthday', `${currentMonth} Points`, `${currentMonth} Points Submitted`]);
                rowHeader2.height = 38
                rowHeader2.alignment = { vertical: 'middle' };
                rowHeader2.font = { bold: true };

                this.applyThinBordersToRowsColumns(sheetTotal, 1, 1, 1, 8);

                for (const key in pointsTotal) {

                    const { firstName, lastName, company, department, employeeNumber, birthday, points, pointsSubmitted } = pointsTotal[key];

                    const newRow = sheetTotal.addRow([
                        firstName,
                        lastName,
                        company,
                        department,
                        employeeNumber,
                        birthday,
                        points,
                        pointsSubmitted,
                    ]);

                    this.applyThinBorders(newRow);
                }
                this.autoResizeColumns(sheetTotal);


                sheetTotal.autoFilter = { from: { row: 1, column: 1 }, to: { row: this.entries.length + 1, column: 8 } };

         
                // Set the first sheet as active
                workbook.views = [{ state: 'frozen', xSplit: 0, ySplit: 0, topLeftCell: 'A1', activeCell: 'A1' }];
                workbook.views[0].activeTab = 0; // Index of the first sheet

                // Export the workbook to a file
                const buffer = await workbook.xlsx.writeBuffer();
                const blob = new Blob([buffer], { type: 'application/octet-stream' });           

                saveAs(blob, `Points_Submission_${this.formatDate(currentDate)}.xlsx`);


            },
            makeBoldFont(row) {
                row.font = { bold: true };
            },
            autoResizeColumns(worksheet) {                
                worksheet.columns.forEach(column => {
                    let maxLength = 0;
                    column.eachCell({ includeEmpty: true }, cell => {
                        const columnLength = cell.value ? cell.value.toString().length : 10;
                        if (columnLength > maxLength) {
                            maxLength = columnLength;
                        }
                    });
                    column.width = maxLength < 10 ? 10 : maxLength;
                });
            },
            applyThinBorders(row) {
                row.eachCell(cell => {
                    cell.border = {
                        top: { style: 'thin' },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' }
                    };
                });
            },
            applyThinBordersToRowsColumns(worksheet, startRow, endRow, startCol, endCol) {
                for (let row = startRow; row <= endRow; row++) {
                    for (let col = startCol; col <= endCol; col++) {
                        worksheet.getCell(row, col).border = {
                            top: { style: 'thin' },
                            left: { style: 'thin' },
                            bottom: { style: 'thin' },
                            right: { style: 'thin' }
                        };
                    }
                }
            },
            async loadImageBase64(url) {
                const response = await fetch(url);
                const blob = await response.blob();
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result.split(',')[1]);
                    reader.onerror = reject;
                    reader.readAsDataURL(blob);
                });
            },

            formatDate(date, format = 'short') {                
                const options = { year: 'numeric', month: format, day: 'numeric' };
                return date.toLocaleDateString(undefined, options);
            },
            formatDate2(date) {
              if (!date) return "";
              const newDate = format(new Date(date), "MM/dd/yyyy"); // Ensure proper date format

              return newDate;
            },
            getCurrentMonth() {
                const date = new Date();
                return date.toLocaleString('default', { month: 'long' });
            }
        }
    }
</script>

